export const LOCAL_MYSTUDIO_API_ORIGIN = "http://127.0.0.1:4000";
export const DEFAULT_LOCAL_PREVIEW_OFFICE_ID = 35;
export const DEFAULT_LOCAL_PREVIEW_OFFICE_NAME = "천안";

const LOCAL_PREVIEW_HOSTNAMES = new Set(["localhost", "127.0.0.1", "::1"]);

function normalizeOrigin(value: unknown): string {
    return String(value || "").trim().replace(/\/+$/, "");
}

function currentHostname(): string {
    if (typeof window === "undefined") {
        return "";
    }

    return window.location.hostname;
}

export function isLocalPreviewHostname(hostname = currentHostname()): boolean {
    return LOCAL_PREVIEW_HOSTNAMES.has(String(hostname || "").trim().toLowerCase());
}

export function resolveMystudioApiOrigin({
    configuredOrigin = process.env.REACT_APP_MYSTUDIO_API_URL,
    hostname = currentHostname(),
}: {
    configuredOrigin?: unknown;
    hostname?: string;
} = {}): string {
    const normalizedOrigin = normalizeOrigin(configuredOrigin);

    if (normalizedOrigin) {
        return normalizedOrigin;
    }

    return isLocalPreviewHostname(hostname) ? LOCAL_MYSTUDIO_API_ORIGIN : "";
}

export function getLocalPreviewOfficeConfig({
    configuredOfficeId = process.env.REACT_APP_MYSTUDIO_PREVIEW_OFFICE_ID,
    configuredOfficeName = process.env.REACT_APP_MYSTUDIO_PREVIEW_OFFICE_NAME,
}: {
    configuredOfficeId?: unknown;
    configuredOfficeName?: unknown;
} = {}) {
    const parsedOfficeId = Number(configuredOfficeId);
    const officeId = Number.isInteger(parsedOfficeId) && parsedOfficeId > 0
        ? parsedOfficeId
        : DEFAULT_LOCAL_PREVIEW_OFFICE_ID;
    const officeName = String(configuredOfficeName || "").trim()
        || DEFAULT_LOCAL_PREVIEW_OFFICE_NAME;

    return {
        officeId,
        officeName,
    };
}
